/*
 * @Author: your name
 * @Date: 2021-08-13 17:04:31
 * @LastEditTime: 2026-01-08 13:10:30
 * @LastEditors: daidongyu daidongyu@cnuri.cn
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: /my-activation/src/page/pagepost.js
 */
import Axios from "axios";
import qs from "qs";

// companyID localstorage.appcode
// const baseUrl =
//   process.env.NODE_ENV === "production"
//     ? "https://api.cnuri.cn"
//     : "https://test-api.cnuri.cn";

// const baseUrl =
//   process.env.NODE_ENV === "production"
//     ? "https://api.cnuri.cn"
//     : process.env.NODE_ENV === "pre"
//     ? "https://test-api.cnuri.cn"
//     : "https://test-api.cnuri.cn";

// const baseUrl = "http://192.168.1.129:9292";
const baseUrl = "https://api.cnuri.cn";
console.log(process.env);
export function R(url, data, success, fail) {
  // 192.168.1.127:9999
  // const URL = "http://192.168.1.127:9999/" + url;
  const URL = "http://www.smartmis.com/vip2webservice/x5service.asmx/" + url;
  // const URL = "/api/"+url
  Axios({
    url: URL,
    data: qs.stringify(data),
    method: "POST"
  })
    .then(res => {
      success(res);
    })
    .catch(err => {
      fail(err);
    });
}
// https://api.cnuri.cn/payment
export function Request(url, data, success, fail) {
  const URL = "https://api.cnuri.cn/wechat-sdk/" + url;
  // const URL = "http://192.168.1.129:9292/wechat-sdk/" + url;
  Axios({
    url: URL,
    data: data,
    headers: {
      "content-type": "application/json",
      "Deji-Key": "890ec0a4944f0023bd46b9d7bff6f357",
      companyID: localStorage.getItem("companyID")
    },
    method: "POST"
  })
    .then(res => {
      success(res);
    })
    .catch(err => {
      fail(err);
    });
}
export function Request1(url, data, success, fail) {
  // 192.168.1.127:9999
  const URL = "https://api.cnuri.cn/payment-pre-stage/" + url;
  // const URL = "http://localhost:8888" + url;
  Axios({
    url: URL,
    data: data,
    headers: {
      "content-type": "application/json",
      "Deji-Key": "890ec0a4944f0023bd46b9d7bff6f357",
      companyID: localStorage.getItem("companyID")
    },
    method: "POST"
  })
    .then(res => {
      success(res);
    })
    .catch(err => {
      fail(err);
    });
}
export function RequestVIP(url, success, fail) {
  const URL = baseUrl + "/vip-h5/api/v2/" + url;
  // const URL = baseUrl + "/vip-h5-pre/api/v2/" + url;
  // const URL = "http://192.168.1.128:9292/api/v2/" + url;
  Axios({
    url: URL,
    // data: data,
    headers: {
      "content-type": "application/json",
      "Deji-Key": "890ec0a4944f0023bd46b9d7bff6f357",
      companyID: localStorage.getItem("companyID")
    },
    method: "GET"
  })
    .then(res => {
      success(res);
    })
    .catch(err => {
      fail(err);
    });
}
export function RequestVIP2(url, data, success, fail) {
  const URL = baseUrl + "/vip-h5/api/v2/" + url;
  // const URL = "http://192.168.1.129:9292/vip-h5/api/v2/" + url;
  Axios({
    url: URL,
    data: data,
    headers: {
      "content-type": "application/json",
      "Deji-Key": "890ec0a4944f0023bd46b9d7bff6f357",
      companyID: localStorage.getItem("companyID")
    },
    method: "POST"
  })
    .then(res => {
      success(res);
    })
    .catch(err => {
      fail(err);
    });
}
export function RequestVIP3(url, data, success, fail) {
  const URL = baseUrl + "/vip-h5/api/v2/" + url;
  // const URL = "http://192.168.1.129:9292/vip-h5/api/v2/" + url;
  Axios({
    url: URL,
    data: data,
    headers: {
      "content-type": "application/json",
      "Deji-Key": "890ec0a4944f0023bd46b9d7bff6f357",
      companyID: localStorage.getItem("companyID")
    },
    method: "PUT"
  })
    .then(res => {
      success(res);
    })
    .catch(err => {
      fail(err);
    });
}
export function RequestMall(method, url, data, success, fail) {
  const URL = baseUrl + "/vip-h5/api/v2/" + url;
  // const URL = "http://192.168.1.129:9292/api/v2/" + url;
  Axios({
    url: URL,
    data: data,
    headers: {
      "content-type": "application/json",
      "Deji-Key": "890ec0a4944f0023bd46b9d7bff6f357",
      companyID: localStorage.getItem("companyID")
    },
    method: method
  })
    .then(res => {
      success(res);
    })
    .catch(err => {
      // fail(err);
    });
}
export function RequestLocal(method, url, data, success, fail) {
  // url: `https://api.cnuri.cn/mp-vip-api${url}`,
  const URL = "https://api.cnuri.cn/mp-vip-api" + url;
  // const URL = "http://192.168.1.129:9292/api/v2/" + url;
  Axios({
    url: URL,
    data: data,
    headers: {
      "content-type": "application/json",
      "Deji-Key": "890ec0a4944f0023bd46b9d7bff6f357",
      companyID: localStorage.getItem("companyID")
    },
    method: method
  })
    .then(res => {
      success(res);
    })
    .catch(err => {
      // fail(err);
    });
}
export function RequestLocalNew(method, url, data, success, fail) {
  // url: `https://api.cnuri.cn/mp-vip-api${url}`,
  const URL = "https://api.cnuri.cn/mp-vip-api-wangjiao" + url;
  // const URL = "http://192.168.1.129:9292/api/v2/" + url;
  Axios({
    url: URL,
    data: data,
    headers: {
      "content-type": "application/json",
      "Deji-Key": "890ec0a4944f0023bd46b9d7bff6f357",
      companyID: localStorage.getItem("companyID")
    },
    method: method
  })
    .then(res => {
      success(res);
    })
    .catch(err => {
      // fail(err);
    });
}
export default {
  R
};



// WEBPACK FOOTER //
// ./src/page/pagepost.js